import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@common/components/Typography";
import { DatasetStatValue } from "./types";

const StatValue = ({
  value,
  index,
  colors,
}: {
  value: DatasetStatValue;
  index: number;
  colors: string[];
}) => {
  return <span style={{ color: colors[index] }}>{value}</span>;
};

type StatValueProps = {
  translationKey: string;
  values: DatasetStatValue[];
  colors: string[];
  unit: string;
};

const Stat = ({ translationKey, values, colors, unit }: StatValueProps) => {
  const { t } = useTranslation();

  const label = t(translationKey);
  const isValuePresent = values.every((value) => value !== "-");

  const formValues = () => {
    return values.map((value, index) => {
      const isLastValue = index === values.length - 1;

      return (
        <Fragment key={index}>
          <StatValue value={value} index={index} colors={colors} />
          {!isLastValue && <span> / </span>}
        </Fragment>
      );
    });
  };

  return (
    <Typography size="medium">
      {label}: {formValues()} {isValuePresent ? unit : ""}
    </Typography>
  );
};

export default Stat;
